export default __webpack_public_path__ + "static/64-ac526706f9a00e755d207db76ec4b744.gif";